export type GatewayTimeFilterInput = {
  dateFrom?: string
  dateTo?: string
}

export type ResolvedGatewayTimeFilter = {
  dateFrom: string
  dateTo: string
}

export const GATEWAY_TIME_FILTER_ALL = {
  dateFrom: '-1',
  dateTo: '-1',
} as const satisfies ResolvedGatewayTimeFilter

/** Backend default: last 24 hours when both values are "0". */
export const GATEWAY_TIME_FILTER_DEFAULT = {
  dateFrom: '0',
  dateTo: '0',
} as const satisfies ResolvedGatewayTimeFilter

export const GATEWAY_TIME_RANGE_PRESET_WINDOWS_MS: Record<string, number> = {
  'last-30-min': 30 * 60 * 1000,
  'last-hour': 60 * 60 * 1000,
  'last-4-hour': 4 * 60 * 60 * 1000,
  'last-12-hour': 12 * 60 * 60 * 1000,
  'last-24-hour': 24 * 60 * 60 * 1000,
  'last-48-hours': 48 * 60 * 60 * 1000,
  'last-3-days': 3 * 24 * 60 * 60 * 1000,
  'last-7-days': 7 * 24 * 60 * 60 * 1000,
  'last-30-days': 30 * 24 * 60 * 60 * 1000,
}
